import React from "react";
import { useTranslation } from "react-i18next";

import defaultImg from "../../../../../img/LOGO.webp";
const noFX = () => {
  return null;
};
const ViewAll = ({ items, navigateTo = noFX }) => {
  const { t } = useTranslation();
  return (
    <div className="d-flex flex-column align-items-center justify-content-center moreItems">
      <div className="d-flex justify-content-center">
        {items.map((item, index) => {
          const iitem = {
            productImg: item?.productImg
              ? item?.productImg
              : item?.comboImage
              ? item?.comboImage
              : item?.imageURL
              ? item?.imageURL
              : defaultImg,
          };
          return (
            <div key={index} className="moreItemsCircle">
              <img
                src={iitem.productImg}
                loading="lazy"
                alt="product"
                width="100%"
                height="100%"
              />
            </div>
          );
        })}
      </div>
      <button
        className="viewall-link"
        type="button"
        onClick={(e) => {
          e.preventDefault();
          navigateTo();
        }}
      >
        {t("View all")} <i className="bi bi-chevron-right"></i>
      </button>
    </div>
  );
};

export default React.memo(ViewAll);
